import { useDropzone } from 'react-dropzone';

import { MAX_FILE_UPLOAD_SIZE } from '../../../../constants';

export const useFewDropzone = ({ holder, setFile, setUploadErrors }) => {
  return useDropzone({
    accept: {
      'image/jpeg': ['.jpeg'],
      'image/png': ['.png'],
      'image/jpg': ['.jpg'],
    },
    onDropAccepted: (acceptedFiles = []) => {
      setUploadErrors((prevErrors) => ({ ...prevErrors, [holder]: null }));

      if (!acceptedFiles[0]) {
        return;
      }

      const image = new Image();

      image.src = URL.createObjectURL(acceptedFiles[0]);

      image.onload = function () {
        setFile((prevFile) => ({
          ...prevFile,
          [holder]: Object.assign(acceptedFiles[0], {
            preview: image.src,
          }),
        }));

        if (image.width > image.height) {
          setUploadErrors((prevErrors) => ({
            ...prevErrors,
            [holder]: {
              message: 'Sorry, we can’t use this image, please upload a portrait image',
            },
          }));
        }
      };

      acceptedFiles.forEach((acceptedFile) => {
        const reader = new FileReader();

        reader.onabort = () => console.warn('file reading was aborted');
        reader.onerror = () => console.error('file reading has failed');
        reader.onload = () => {
          // Do whatever you want with the file contents
          const binaryStr = reader.result;

          // @ts-ignore - TECH DEBT to resolve later
          setFile((prevFile) => ({
            ...prevFile,
            [holder]: Object.assign(acceptedFiles[0], {
              binaryStr,
            }),
          }));
        };
        reader.readAsArrayBuffer(acceptedFile);
      });
    },
    onDropRejected: (reason) => {
      console.warn(reason);
      setUploadErrors((prevErrors) => ({
        ...prevErrors,
        [holder]: reason[0]?.errors[0],
      }));
    },
    multiple: false,
    maxFiles: 1,
    maxSize: MAX_FILE_UPLOAD_SIZE,
  });
};
